import { ICuttingBaseMaterial } from './cutting-base-material.model';

export class CuttingMatBaseFurniture implements ICuttingBaseMaterial {
  groupId: number;
  id: number;
  name: string;
  article: string;
  textureName: string;
  textureRotationDegree: number;
  color: string;
  measureName: string;
  price: number;
  weightPerItem: number;
  roundMode: RoundModeEnum;
  roundNumber: number;
  textureLink: string;
  cropTextureLink: string;
  quantityInStock: number;
  discountPct: number;
}

export enum RoundModeEnum {
  None,
  Ceiling,
  ToNumber,
}
